import * as React from 'react';
import { useTheme } from '../../../../theme';

interface Props {
	visible: number;
}

const ListTransition: React.FunctionComponent<Props> = props => {
	const innerRef = React.useRef<HTMLDivElement>(null),
		outerRef = React.useRef<HTMLDivElement>(null),
		theme = useTheme('Contacts').ListTransitionStyles;

	React.useEffect(() => {
		innerRef.current.childNodes.forEach((child, index) => {
			(child as HTMLDivElement).classList.add(theme.item);

			if (index === props.visible) {
				(child as HTMLDivElement).classList.remove(theme.item_gone);
			} else {
				(child as HTMLDivElement).classList.add(theme.item_gone);
			}
		});

		const height = outerRef.current.offsetHeight;

		innerRef.current.style.transform = `translateY(-${height * props.visible}px)`;
	}, [props.visible]);

	return (
		<div ref={outerRef} className={theme.container}>
			<div ref={innerRef} className={theme.list}>
				{props.children}
			</div>
		</div>
	);
};

export default ListTransition;
